<div class="reference-input-field">
  <span class="ds-caption reference-input-label">{{ '#CORE_FILTER.DATE.RANGE' | translate }}</span>
  <soft-ds-date-range-input size="md"
                            [value]="range()"
                            (valueChange)="range.set($event)"
                            data-testid="date-range-reference-input-range" />
</div>
<div class="reference-input-field">
  <span class="ds-caption reference-input-label">{{ '#CORE_FILTER.DATE.COMPARISON' | translate }}</span>
  <soft-ds-date-range-input size="md"
                            [value]="reference()"
                            (valueChange)="reference.set($event)"
                            data-testid="date-range-reference-input-reference" />
</div>
